export default "__VITE_ASSET__3S3DYDV7__"